import { Link } from "react-router-dom";
import { CalendarDays } from "lucide-react";

const BookCta = ({ className = "", testId = "cta-book-appointment", compact = false }) => (
  <Link
    to="/#prenota"
    data-testid={testId}
    className={
      compact
        ? "inline-flex items-center gap-2 rounded-full bg-gold px-4 py-2 text-xs sm:text-sm font-semibold text-navy shadow-md shadow-gold/30 transition-all duration-300 hover:bg-gold-light active:scale-95"
        : `btn-gold ${className}`
    }
  >
    <CalendarDays size={compact ? 14 : 16} aria-hidden="true" />
    <span>Prenota un appuntamento</span>
  </Link>
);

export default BookCta;
